import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getUser, postUpSertUser } from "../../core/api/Api";
import { showToast } from "../../core/common-service/CommonService";
import Loading from "../common/loading/Loading";

const Profile = () => {
  const { t } = useTranslation();
  const mounted = useRef(true);
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(false);
  // Default to true (disabled) for safety - old users who logged in before this feature
  // won't have this value set, so we disable email editing for them until they re-login
  const isGoogleLogin = localStorage.getItem("isGoogleLogin") !== "false";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleSubmit = (e) => {
    const obj = {
      id: userDetails?.id,
      first_name: userDetails?.first_name,
      last_name: userDetails?.last_name,
      city: userDetails?.city,
    };
    if (!isGoogleLogin) {
      obj.email = userDetails?.email;
    }
    setLoading(true);
    postUpSertUser(obj)
      .then((res) => {
        setLoading(false);
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setUserDetails(data);
        }
        showToast({ type: "success", message: t("user_updated_successfully") });
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const getUserDetails = () => {
    setLoading(true);
    getUser()
      .then((res) => {
        setLoading(false);
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setUserDetails(data);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getUserDetails();
    return () => {
      mounted.current = false;
    };
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <section
      className="aai-signup-in"
    >
      {userDetails?.email && (
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-2 col-lg-4 d-none d-xl-block order-2 order-lg-1">
              <div className="position-relative"></div>
            </div>
            <div className="col-xl-8 order-1 ps-xl-5 order-lg-2 mb-5 mb-lg-0">
              <div className="aai-form-wrapper">
                <div className="">
                  <div className="aai-form-header d-flex justify-content-center text-center flex-column align-items-center mb-3">
                    <h2 className="aai-form-title">{t("edit_your_info")}</h2>
                  </div>
                </div>
                <div>
                  <div>
                    <div className="row g-3">
                      <div className="col-lg-12">
                        <div className="aai-form-container">
                          <input
                            className="form-control shadow-none"
                            id="first_name"
                            name="first_name"
                            type="text"
                            placeholder={t("enter_your_first_name")}
                            value={userDetails?.first_name}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="aai-form-container">
                          <input
                            className="form-control shadow-none"
                            id="last_name"
                            name="last_name"
                            type="text"
                            placeholder={t("enter_your_last_name")}
                            value={userDetails?.last_name}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="aai-form-container">
                          <input
                            className="form-control shadow-none"
                            id="email"
                            name="email"
                            type="email"
                            value={userDetails?.email}
                            placeholder={t("enter_your_email")}
                            disabled={isGoogleLogin}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="aai-form-container">
                          <input
                            className="form-control shadow-none"
                            id="city"
                            name="city"
                            type="text"
                            placeholder={t("enter_your_city")}
                            value={userDetails?.city}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="d-grid">
                          <button
                            onClick={handleSubmit}
                            type="submit"
                            disabled={loading}
                            className="aai-btn btn-pill-solid"
                          >
                            {t("submit")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Profile;
